import { FORM_VALIDATION_MSG } from '../constants';

const getDefaultNoFreightInfo = () => {
  return {
    noFreightCode: null,
    contactName: '',
    callTime: '',
    comments: '',
    errorInfo: {
      noFreightCode: null,
      contactName: '',
      callTime: '',
      comments: ''
    }
  };
};

const getFieldError = (field, value, shouldEnforceNoFreightReasonCode = false) => {
  switch (field) {
    case 'noFreightCode':
      if (shouldEnforceNoFreightReasonCode) {
        return value ? null : FORM_VALIDATION_MSG.REQUIRED;
      }
      return null;
    case 'contactName':
    case 'callTime':
    case 'comments':
      return value?.trim() ? null : FORM_VALIDATION_MSG.REQUIRED;
    default:
      return null;
  }
};

const getNoFreightErrorInfo = ({
  errorInfo,
  noFreightPickupData,
  shouldEnforceNoFreightReasonCode = false
}) => {
  const newErrorInfo = {};
  Object.keys(errorInfo).forEach((fieldName) => {
    newErrorInfo[fieldName] = getFieldError(
      fieldName,
      noFreightPickupData[fieldName],
      shouldEnforceNoFreightReasonCode
    );
  });
  return newErrorInfo;
};

export { getDefaultNoFreightInfo, getFieldError, getNoFreightErrorInfo };
